import React from 'react';
import './LoginButtons.css';


const ImageComponent = ({ src, alt }) => {
    return (
        <div className='msg-container'>
            <img src={src} alt={alt} />
        </div>
    );
};

export default ImageComponent;


